import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqWhatsapp = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/whatsapp", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco,
					page,
				},
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},

	listID: async function (id) {
		return apiServer
			.get(`portal/v1/whatsapp/${id}`, {
				headers: {
					banco,
				},
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},

	insert: async function (data) {
		return apiServer
			.post("portal/v1/whatsapp", data, {
				headers: {
					banco,
				},
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
	updateTelefone: async function (instancia, telefone) {
		return apiServer
			.patch(
				"portal/v1/whatsapp/telefone",
				{ instancia, telefone },
				{
					headers: {
						banco,
					},
				}
			)
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
	updateDesativar: async function (instancia, telefone, ativo) {
		return apiServer
			.patch(
				"portal/v1/whatsapp/desativar",
				{ instancia, telefone, ativo },
				{
					headers: {
						banco,
					},
				}
			)
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
	listAll: async function () {
		return apiServer
			.get("portal/v1/whatsapp/all", {
				headers: {
					banco,
				},
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
};

export default reqWhatsapp;
